export default "__VITE_ASSET__CvsVZ2hg__"